module.exports = __webpack_public_path__ + "fonts/Satoshi-Medium.d607ace.woff2";